interface Config {
  PARTNERS_URL: string;
  Z3_URL: string;
  GOOGLE_CLIENT_ID: string;
  PUSHER_APP_KEY: string;
  PUSHER_APP_CLUSTER: string;
  DEPLOYMENT_CHANNEL: string;
  HOTJAR_SITE_ID?: number;
  HOTJAR_VERSION?: number;
  RUM_APP_MONITOR_ID: string;
  RUM_IDENTITY_POOL_ID: string;
  RUM_ENVIRONMENT: 'dev' | 'prod';
}

const local: Config = {
  PARTNERS_URL: 'http://localhost:3000/',
  Z3_URL: 'http://localhost:8080/',
  GOOGLE_CLIENT_ID: '914813737628-gb5aqgfqt1lb1l7nh16it6d9f4gh7obc.apps.googleusercontent.com',
  PUSHER_APP_KEY: '06182979eb72c66e3ee0',
  PUSHER_APP_CLUSTER: 'us3',
  DEPLOYMENT_CHANNEL: 'z4-deployments-staging',
  RUM_APP_MONITOR_ID: '4337c316-50ba-4450-9544-bc74538a33ce',
  RUM_IDENTITY_POOL_ID: 'us-west-2:b0dedd49-5b15-49ee-ac7e-0ec2995a7586',
  RUM_ENVIRONMENT: 'dev',
};

const dev: Config = {
  PARTNERS_URL: 'http://localhost:3000/',
  Z3_URL: 'https://www-staging.zicasso.com/',
  GOOGLE_CLIENT_ID: '914813737628-gb5aqgfqt1lb1l7nh16it6d9f4gh7obc.apps.googleusercontent.com',
  PUSHER_APP_KEY: '06182979eb72c66e3ee0',
  PUSHER_APP_CLUSTER: 'us3',
  DEPLOYMENT_CHANNEL: 'z4-deployments-staging',
  RUM_APP_MONITOR_ID: '4337c316-50ba-4450-9544-bc74538a33ce',
  RUM_IDENTITY_POOL_ID: 'us-west-2:b0dedd49-5b15-49ee-ac7e-0ec2995a7586',
  RUM_ENVIRONMENT: 'dev',
};

const staging: Config = {
  PARTNERS_URL: 'https://partners-staging.zicasso.com/',
  Z3_URL: 'https://www-staging.zicasso.com/',
  GOOGLE_CLIENT_ID: '914813737628-gb5aqgfqt1lb1l7nh16it6d9f4gh7obc.apps.googleusercontent.com',
  PUSHER_APP_KEY: '06182979eb72c66e3ee0',
  PUSHER_APP_CLUSTER: 'us3',
  DEPLOYMENT_CHANNEL: 'z4-deployments-staging',
  HOTJAR_SITE_ID: 3744985,
  HOTJAR_VERSION: 6,
  RUM_APP_MONITOR_ID: '4337c316-50ba-4450-9544-bc74538a33ce',
  RUM_IDENTITY_POOL_ID: 'us-west-2:b0dedd49-5b15-49ee-ac7e-0ec2995a7586',
  RUM_ENVIRONMENT: 'dev',
};

const qa: Config = {
  PARTNERS_URL: 'https://partners-qa.zicasso.com/',
  Z3_URL: 'https://www-qa.zicasso.com/',
  GOOGLE_CLIENT_ID: '914813737628-gb5aqgfqt1lb1l7nh16it6d9f4gh7obc.apps.googleusercontent.com',
  PUSHER_APP_KEY: '06182979eb72c66e3ee0',
  PUSHER_APP_CLUSTER: 'us3',
  DEPLOYMENT_CHANNEL: 'z4-deployments-qa',
  RUM_APP_MONITOR_ID: '4337c316-50ba-4450-9544-bc74538a33ce',
  RUM_IDENTITY_POOL_ID: 'us-west-2:b0dedd49-5b15-49ee-ac7e-0ec2995a7586',
  RUM_ENVIRONMENT: 'dev',
};

const prod: Config = {
  PARTNERS_URL: 'https://partners.zicasso.com/',
  Z3_URL: 'https://www.zicasso.com/',
  GOOGLE_CLIENT_ID: '914813737628-gb5aqgfqt1lb1l7nh16it6d9f4gh7obc.apps.googleusercontent.com',
  PUSHER_APP_KEY: '88f77513b2a5e074a7e5',
  PUSHER_APP_CLUSTER: 'us3',
  DEPLOYMENT_CHANNEL: 'z4-deployments-prod',
  HOTJAR_SITE_ID: 3729916,
  HOTJAR_VERSION: 6,
  RUM_APP_MONITOR_ID: 'abc7eb69-1c36-4942-96f9-a94c7e867009',
  RUM_IDENTITY_POOL_ID: 'us-west-2:e4b128d9-b7e0-461f-9919-828e7fe173e2',
  RUM_ENVIRONMENT: 'prod',
};

export const z3ApiEndpoint: { [key: string]: string } = {
  dev: 'https://api-staging.zicasso.com',
  prod: 'https://api.zicasso.com',
  production: 'https://api.zicasso.com',
  qa: 'https://api-qa.zicasso.com',
  staging: 'https://api-staging.zicasso.com',
  local: 'http://api-staging.zicasso.com',
};

export const z3Endpoint: { [key: string]: string } = {
  dev: 'https://www-staging.zicasso.com',
  prod: 'https://www.zicasso.com',
  production: 'https://www.zicasso.com',
  qa: 'https://www-qa.zicasso.com',
  staging: 'https://www-staging.zicasso.com',
  local: 'http://www-staging.zicasso.com',
};

// eslint-disable-next-line import/no-mutable-exports
let config: Config;
if (process.env.REACT_APP_STAGE === 'prod') {
  config = { ...prod };
} else if (process.env.REACT_APP_STAGE === 'staging') {
  config = { ...staging };
} else if (process.env.REACT_APP_STAGE === 'qa') {
  config = { ...qa };
} else if (process.env.REACT_APP_STAGE === 'local') {
  config = { ...local };
} else {
  config = { ...dev };
}

export default config;
